import { useState } from 'react';
import { Extension } from '../../../../../../Classes/ResponseModels/ApplicationManagement/AppManagementModel';
import ExtensionTypeRequest from '../../../../../../Classes/ResponseModels/ApplicationManagement/ExtensionTypeRequest.js';
import { CreateExtensionType } from '../../../../_api';
import styles from '../../../../ApplicationMaintenance.module.scss';
import ApiErrors from '../../../../components/NewApplication/ApiErrors';
import Modal from '@mui/material/Modal';
import Base from '../../../../../Base/Base';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import Spinner from '../../../../../../components/UI/Spinner/Spinner';
import classNames from 'classnames';
import Section from '../../../../components/NewApplication/Section';

// @app : AppManagementModel
// @currentUser : userProfile from useIdentify() hook
//reload : function, called after a new extension is saved
const ExtensionTypeCreate = ({
	app,
	currentUser,
	reload,
	disabled,
	requirementNumber,
}) => {
	//API Call implemented end to end
	//handle error using response from CreateExtensionType
	////If response.App.Errors.length > 0, an error occured
	////else the new application Extensions are response.app.Extensions

	//initialize new Extension with appID
	let initialExtensionState = new Extension();
	initialExtensionState.appID = app.appMaster.id;
	initialExtensionState.hide = 0;
	initialExtensionState.order = app.extensions?.length + 1;

	const [newExtension, setNewExtension] = useState(initialExtensionState);
	const [modalOpen, setModalOpen] = useState(false);
	const [apiErrors, setApiErrors] = useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const handleChange = e => {
		setNewExtension({
			...newExtension,
			[e.target.name]: e.target.value,
		});
	};

	const handleSave = () => {
		setIsLoading(true);
		let request = new ExtensionTypeRequest(
			app,
			currentUser,
			newExtension,
			requirementNumber
		);
		request.RequirementNumber = requirementNumber;
		CreateExtensionType(request)
			.then(response => {
				setApiErrors(response?.App?.Errors);
			})
			.then(x => {
				//if no errors, close modal and reload extensions
				setIsLoading(false);

				if (apiErrors.length === 0) {
					setModalOpen(false);
					//reload the extensions to reflect the changes to the extensions if no errors
					reload();
				}
			});
	};

	//resolve error message cause by null value on inputs
	const resolveTextAreaNull = value => {
		if (value === null) {
			return '';
		} else return value;
	};
	return (
		<div>
			<div className={styles.controlsContainer}>
				<Button
					id='extension_type_create_modal_open'
					onClick={() => setModalOpen(true)}
					startIcon={<MaterialIcon icon='add' />}
					disabled={disabled}
					variant={'outlined'}
				>
					Add Extension
				</Button>
			</div>
			<Modal
				open={modalOpen}
				onClose={() => {
					setNewExtension(new Extension());
					setApiErrors([]);
					setModalOpen(false);
				}}
			>
				<div className={styles.Modal}>
					<Base title='Create Extension Type'>
						{isLoading ? (
							<Spinner />
						) : (
							<>
								<ApiErrors errors={apiErrors} />
								<div className={styles.controlsContainer}>
									<Button
										onClick={e => {
											handleSave();
										}}
										outlined
										startIcon={<MaterialIcon icon='save' />}
										className={styles.editButton}
										id='createExtension_Save'
										disabled={disabled}
									>
										Save
									</Button>
								</div>

								<Section label='Create New Extension Type'>
									<div>
										{/* description : string (256) */}
										<div className={styles.detailLabel}>
											<p>
												Description{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{newExtension?.description
														?.length
														? newExtension
																.description
																.length
														: 0}
													/{256})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
												])}
												type='text'
												value={resolveTextAreaNull(
													newExtension.description
												)}
												onChange={e => handleChange(e)}
												name='description'
												maxLength={256}
												rows={5}
												id='newExtension_description'
											/>
										</div>

										{/* full : string (256) */}
										<div className={styles.detailLabel}>
											<p>
												Full{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{newExtension?.full?.length
														? newExtension.full
																.length
														: 0}
													/{256})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
													styles.margin_top_1,
												])}
												type='text'
												value={resolveTextAreaNull(
													newExtension.full
												)}
												onChange={e => handleChange(e)}
												name='full'
												maxLength={256}
												rows={5}
												id='newExtension_full'
											/>
										</div>

										{/* short : string (256) */}
										<div className={styles.detailLabel}>
											<p>
												Short{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{newExtension?.short?.length
														? newExtension?.short
																?.length
														: 0}
													/{256})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
													styles.margin_top_1,
												])}
												type='text'
												value={resolveTextAreaNull(
													newExtension?.short
												)}
												onChange={e => handleChange(e)}
												name='short'
												maxLength={256}
												rows={5}
												id='newExtension_short'
											/>
										</div>

										{/* order : int  */}
										<div className={styles.detailLabel}>
											<p>Order </p>

											<input
												type='number'
												value={newExtension?.order}
												onChange={e => handleChange(e)}
												name='order'
												min={0}
												id='newExtension_order'
											/>
										</div>
										{/* f_Save_Override_Value : string (255) */}
										<div className={styles.detailLabel}>
											<p>
												Save Override Value{' '}
												<span
													className={
														styles.characterCount
													}
												>
													(
													{newExtension
														?.f_Save_Override_Value
														?.length
														? newExtension
																?.f_Save_Override_Value
																?.length
														: 0}
													/{255})
												</span>
											</p>

											<textarea
												className={classNames([
													styles.detailInfo,
													styles.textArea,
													styles.margin_top_1,
												])}
												type='text'
												value={resolveTextAreaNull(
													newExtension?.f_Save_Override_Value
												)}
												onChange={e => handleChange(e)}
												name='f_Save_Override_Value'
												maxLength={255}
												rows={5}
												id='newExtension_save_override'
											/>
										</div>
									</div>
								</Section>
								<div className={styles.controlsContainer}>
									<Button
										onClick={e => {
											handleSave();
										}}
										outlined
										startIcon={<MaterialIcon icon='save' />}
										className={styles.editButton}
										id='createExtension_Save2'
										disabled={disabled}
									>
										Save
									</Button>
								</div>
							</>
						)}
					</Base>
				</div>
			</Modal>
		</div>
	);
};

export default ExtensionTypeCreate;
